import React from "react";
import ViewDestination from "../component/Destination/ViewDestination";

const Destination = () => {
  return (
    <>
      <ViewDestination />
    </>
  );
};

export default Destination;
